import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Card, Modal, Tabs } from "antd";
import AddMemberSection from "./AddMemberSection";
import EditMemberSection from "./EditMemberSection";
import MembersListSection from "./MembersListSection";
import useMembers from "./useMembers";
import useModal from "antd/lib/modal/useModal";


export default function MembersPage(props) {

    const { isLoading, isPending, data, getMembers, createMember, updateMembers, deleteMembers } = useMembers();
    const [modal, contextHolder] = useModal();

    const [currentState, setCurrentState] = useState({
        activeKey: "List Members", editableTab: null
    });

    const addEditTab = (username, email, role) => {
        setCurrentState({ activeKey: `Edit Member ${username}`, editableTab: { username, email, role } });
    };

    const removeEditTab = (targetKey) => {
        setCurrentState({ activeKey: targetKey, editableTab: null });
    }

    const onTabChange = (targetKey) => {
        setCurrentState({ ...currentState, activeKey: targetKey });
    }

    const onTabEdit = (targetKey) => removeEditTab("List Members");

    const disabledState = !!(isLoading || isPending);

    return (
        <>
            <div>{contextHolder}</div>
            <Card bordered={false}>
                <Tabs
                    hideAdd={true}
                    type="editable-card"
                    activeKey={currentState.activeKey}
                    items={[
                        {
                            key: "List Members",
                            label: "List Members",
                            closable: false,
                            children: <MembersListSection
                                data={data}
                                disabled={disabledState}
                                onEdit={(username, email, role) => {
                                    addEditTab(username, email, role);
                                }}
                                onDelete={(username) => {
                                    modal.confirm({
                                        title: `Delete user "${username}"?`,
                                        content: `This will delete this user \
                                            from the user pool. They will be \
                                            permanently removed and will no longer \
                                            be able to sign in`,
                                        centered: true,
                                        okText: "Delete",
                                        okType: "danger",
                                        cancelText: "Cancel",
                                        onOk: () => deleteMembers({ data: { username } })
                                            .then(() => getMembers())
                                            .then(() => removeEditTab("List Members")),
                                        onCancel: () => Modal.destroyAll()
                                    })
                                }}
                            />
                        },
                        {
                            key: "Add A New Member",
                            label: "Add A New Member",
                            closable: false,
                            children: <AddMemberSection
                                disabled={disabledState}
                                onAdd={(username, email, role) => {
                                    createMember({ data: { username, email, role } })
                                        .then(() => getMembers())
                                        .then(() => removeEditTab("List Members"));
                                }}
                            />
                        },
                        (currentState.activeKey && currentState.editableTab) &&
                        {
                            key: `Edit Member ${currentState.editableTab.username}`,
                            label: `Edit Member ${currentState.editableTab.username}`,
                            children: (
                                <EditMemberSection
                                    disabled={disabledState}
                                    username={currentState.editableTab.username}
                                    email={currentState.editableTab.email}
                                    role={currentState.editableTab.role}
                                    onEdit={(username, email, role) => {
                                        updateMembers({ data: { username, email, role } })
                                            .then(() => getMembers())
                                            .then(() => removeEditTab("List Members"));
                                    }}
                                />
                            )
                        }
                    ]}
                    onChange={onTabChange}
                    onEdit={onTabEdit}
                />
            </Card>
        </>
    );
}
